import { useState } from 'react';

import { StrictDict } from 'utils';

export const state = StrictDict({
  expandedIndex: (val) => useState(val), // eslint-disable-line
});

/**
 * Single-open accordion: tracks which product row (by index) is currently
 * expanded, and toggles it closed if it's clicked again.
 */
export const useProductAccordion = () => {
  const [expandedIndex, setExpandedIndex] = state.expandedIndex(null);
  const toggle = (index) => setExpandedIndex(expandedIndex === index ? null : index);
  return { expandedIndex, toggle };
};

export default useProductAccordion;
